// Three.js and app-specific imports
import * as THREE from "three";
import { DrawingGlobals, VARS } from "../Global/variables";
import { createMeasurementLabels } from "./Labels";
import { GEOMETRIES, MATERIALS } from "../Global/materials";
import { createEdgesWireframe } from "../Global/functions";

/**
 * Creates a visual vertex (a small circle) at the given position.
 *
 * @param {THREE.Vector3} position - The position to place the vertex.
 * @returns {THREE.Mesh} A mesh representing a polygon vertex.
 */
export const createVertex = (position) => {
    const circle = new THREE.Mesh(
        GEOMETRIES.polygonVertex,
        MATERIALS.polygonVertex.clone()
    );
        console.log("Drawing vertex");
    circle.position.copy(position);
    circle.name = "vertex";
    circle.renderOrder = 1; // Ensures this renders above other objects
    return circle;
};

/**
 * Creates visual and data representations of edges between vertices.
 * Adds measurement labels, edge metadata, and setback information.
 *
 * @param {THREE.Vector3[]} coordinates - List of vertex positions.
 * @param {THREE.Scene} scene - The scene to add labels to.
 * @returns {object} An object containing:
 *   - edgeData: measurement info and IDs for each edge.
 *   - edgeWireframe: visual line segments connecting the edges.
 *   - setBackData: geometry-based setback metadata for each edge.
 */
export const createEdges = (coordinates, scene) => {
    const edgePoints = [];     // Used for visual wireframe
    const edgeData = [];       // Stores measurement and vertex ID metadata
    const setBackData = [];    // Used for offset/setback logic

    const vertices = DrawingGlobals.verticesMesh;

    console.log("Drawing edges");
    

    for (let i = 0; i < coordinates.length; i++) {
        let index = (i + 1) % coordinates.length;
        const point1 = coordinates[i];
        const point2 = coordinates[index];

        edgePoints.push(point1, point2);

        // Create label and measurement for this edge
        let data = createMeasurementLabels(point1, point2, i, scene);
        data.vertexId1 = vertices[i].uuid;
        data.vertexId2 = vertices[index].uuid;

        // Store setback data for edge
        const setback = {
            vertexId1: vertices[i].uuid,
            vertexId2: vertices[index].uuid,
            value: 0,
            point1: point1.clone(),
            point2: point2.clone()
        };

        setBackData.push(setback);
        edgeData.push(data);
    }

    // Increment the global measurement label counter
    VARS.measurementLabelCounter++;

    // Create the visual wireframe lines between the edge points
    const material = MATERIALS.polygonWireframe.clone();
    const edgeWireframe = createEdgesWireframe(edgePoints, material);

    return {
        edgeData,
        edgeWireframe,
        setBackData
    };
};
